import { toAttributes } from '../common/internal';
export function createResource(resource) {
    return {
        attributes: toAttributes(resource.attributes),
        droppedAttributesCount: 0,
    };
}
//# sourceMappingURL=internal.js.map